import { render, staticRenderFns } from "./sign-up-friend.vue?vue&type=template&id=125950c7&scoped=true&lang=pug&"
import script from "./sign-up-friend.vue?vue&type=script&lang=js&"
export * from "./sign-up-friend.vue?vue&type=script&lang=js&"
import style0 from "./sign-up-friend.vue?vue&type=style&index=0&id=125950c7&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125950c7",
  null
  
)

export default component.exports